import React from 'react';
import { Check } from 'lucide-react';

const WebhookSection = () => {
  return (
    <section className="py-16 sm:py-24 px-3 sm:px-4 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-16 items-center">
          {/* Content */}
          <div>
            <p className="text-yellow-500 font-medium mb-3 sm:mb-4 uppercase tracking-wide text-xs sm:text-sm">3rd Party Integration</p>
            <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Webhook<br /><span className="italic">Workflow</span>
            </h2>
            <p className="text-gray-600 text-sm sm:text-lg leading-relaxed mb-6 sm:mb-8">
              Unlock limitless possibilities with waatee's chatbot. Integrate with your
              favorite tools using 3rd party webhooks for seamless workflow and enhanced customer
              engagement.
            </p>
            
            <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-yellow-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-yellow-600" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">Connect with your existing tools seamlessly</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-yellow-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-yellow-600" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">Automate workflows with custom webhooks</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-yellow-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-yellow-600" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">Enhance customer engagement at scale</span>
              </li>
            </ul>

            <a
              href="https://app.waatee.com/register"
              className="inline-flex items-center bg-[#25D366] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-medium hover:bg-[#1da851] transition-colors text-sm sm:text-base"
            >
              Get started
            </a>
          </div>

          {/* Visual - User Cards */}
          <div className="relative">
            <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-xl sm:rounded-2xl p-3 sm:p-4 md:p-8">
              <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
                {/* User Card 1 */}
                <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-3 sm:p-4 md:p-6 w-full sm:w-48 sm:transform sm:-rotate-3 hover:rotate-0 transition-transform">
                  <div className="w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full mx-auto mb-3 sm:mb-4 flex items-center justify-center">
                    <svg className="w-6 sm:w-8 h-6 sm:h-8 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                  <p className="font-semibold text-gray-800 text-center text-xs sm:text-sm">Andy Smith</p>
                  <p className="text-gray-400 text-[10px] sm:text-xs text-center truncate">andysmith@mail.com</p>
                  <div className="mt-3 sm:mt-4 bg-[#25D366] rounded-lg py-1.5 sm:py-2 px-3 sm:px-4 text-white text-xs sm:text-sm text-center font-medium">
                    Message
                  </div>
                </div>
                
                {/* User Card 2 */}
                <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-3 sm:p-4 md:p-6 w-full sm:w-48 sm:transform sm:rotate-3 sm:mt-8 hover:rotate-0 transition-transform">
                  <div className="w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-br from-pink-100 to-pink-200 rounded-full mx-auto mb-3 sm:mb-4 flex items-center justify-center">
                    <svg className="w-6 sm:w-8 h-6 sm:h-8 text-pink-500" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                  <p className="font-semibold text-gray-800 text-center text-xs sm:text-sm">Sarah Lee</p>
                  <p className="text-gray-400 text-[10px] sm:text-xs text-center truncate">sarah.lee@mail.com</p>
                  <div className="mt-3 sm:mt-4 bg-[#25D366] rounded-lg py-1.5 sm:py-2 px-3 sm:px-4 text-white text-xs sm:text-sm text-center font-medium">
                    Message
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebhookSection;
